import styled from "styled-components";
import Loader from "react-loader-spinner";
// Constants
import { primaryColor } from "../config/constants";

export const LoaderDiv = styled.div`
  margin: 20px auto;
  width: 100%;
  max-width: 100px;
`;

const LoaderComponent = ({ width = 100, height = 100, color = primaryColor }) => (
  <LoaderDiv>
    <Loader type="Oval" color={color} height={height} width={width} />
  </LoaderDiv>
);

export default LoaderComponent;
